import React, { ReactNode } from 'react'
import Layout from '../components/layout'
import Styles from '../styles'
import SEO from '../components/seo'
// @ts-ignore
import { MDXProvider } from '@mdx-js/react'
import Code from '../components/code'

const BaseLayout = ({
    children,
    withSidebar = false,
    hasLogin = false,
}: {
    children: ReactNode
    withSidebar?: boolean
    hasLogin?: boolean
}) => (
    <MDXProvider components={{ code: Code }}>
        <Styles />
        <SEO title={'GIPHY Developers'} />
        <Layout withSidebar={withSidebar} hasLogin={hasLogin}>
            {children}
        </Layout>
    </MDXProvider>
)

export default BaseLayout
